import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class SalesSupportUserType {
  public readonly key = 'SalesSupportUserType';
  public readonly enrollTrackRole = EnrollTrackRole.SalesSupport;
}
